import { useIntl } from 'react-intl';

const useDefaultMinLengthFieldError = () => {
  const intl = useIntl();

  return (min: number) => ({
    min,
    message: intl.formatMessage(
      { id: 'commons.form.errors.minLength' },
      { min },
    ),
  });
};

export default useDefaultMinLengthFieldError;
